(function () {
  /* --- Recently viewed: variant image helpers (match ciw-variant-front/hover-url.liquid) --- */
  function ciwNormalizeSrc(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) return 'https:' + src;
    return src;
  }

  function ciwBaseImageUrl(url) {
    return (url || '').split('?')[0];
  }

  function ciwMediaSrc(media) {
    if (!media) return '';
    if (media.src) return ciwNormalizeSrc(media.src);
    if (media.preview_image && media.preview_image.src) {
      return ciwNormalizeSrc(media.preview_image.src);
    }
    return '';
  }

  function ciwGetColorOptionMeta(product) {
    var options = product.options || [];
    for (var i = 0; i < options.length; i++) {
      var name = (options[i].name || '').toLowerCase();
      if (name === 'color' || name === 'colour') {
        return {
          position: options[i].position,
          valueCount: (options[i].values || []).length
        };
      }
    }
    return { position: 0, valueCount: 0 };
  }

  function ciwGetVariantColor(product, variant, colorPosition) {
    var color = '';
    if (colorPosition === 1) color = variant.option1;
    else if (colorPosition === 2) color = variant.option2;
    else if (colorPosition === 3) color = variant.option3;

    if (!color && variant.title && variant.title.indexOf(' / ') !== -1) {
      color = variant.title.split(' / ').pop();
    } else if (!color) {
      color = variant.public_title || variant.title || '';
    }
    return (color || '').trim();
  }

  function ciwMatchColorInAlt(alt, product, colorPosition) {
    var matched = '';
    var bestLen = 0;
    (product.variants || []).forEach(function (variant) {
      var checkColor = ciwGetVariantColor(product, variant, colorPosition);
      if (checkColor && alt.indexOf(checkColor) !== -1 && checkColor.length > bestLen) {
        matched = checkColor;
        bestLen = checkColor.length;
      }
    });
    return matched;
  }

  function ciwIsSideAlt(alt) {
    var altLower = (alt || '').toLowerCase();
    return altLower.indexOf(' side') !== -1 || altLower.indexOf('(side') !== -1 || altLower.indexOf(' angle') !== -1;
  }

  function ciwIsSideFilename(src) {
    var srcLower = (src || '').toLowerCase();
    return (
      srcLower.indexOf('-side.') !== -1 ||
      srcLower.indexOf('_side.') !== -1 ||
      srcLower.indexOf('-side?') !== -1 ||
      srcLower.indexOf('_side?') !== -1
    );
  }

  function ciwGetCardVariant(product) {
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }
    return variants[0] || null;
  }

  function ciwGetVariantAssignedImageSrc(product, variant) {
    if (!variant) return '';
    if (variant.featured_image && variant.featured_image.src) {
      return ciwNormalizeSrc(variant.featured_image.src);
    }
    var imageId = variant.image_id;
    if (!imageId) return '';
    var imgs = product.images || [];
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img && img.id === imageId && img.src) {
        return ciwNormalizeSrc(img.src);
      }
    }
    return '';
  }

  function ciwImageIsSide(alt, src) {
    return ciwIsSideAlt(alt) || ciwIsSideFilename(src);
  }

  function ciwScanColorMatchedGallery(product, variantColor, colorPosition) {
    var galleryFront = null;
    var gallerySide = null;
    var variantColorL = (variantColor || '').toLowerCase();

    function considerImage(alt, src) {
      if (!alt) return;
      var matched = ciwMatchColorInAlt(alt, product, colorPosition) === variantColor;
      if (!matched && variantColorL && alt.toLowerCase().indexOf(variantColorL) === -1) return;
      if (!matched && variantColorL && alt.toLowerCase().indexOf(variantColorL) !== -1) {
        matched = true;
      }
      if (!matched) return;
      if (ciwImageIsSide(alt, src)) {
        if (!gallerySide) gallerySide = src;
      } else if (!galleryFront) {
        galleryFront = src;
      }
    }

    (product.media || []).forEach(function (media) {
      if (media.media_type !== 'image') return;
      considerImage(media.alt || '', ciwMediaSrc(media));
    });

    (product.images || []).forEach(function (img) {
      if (!img) return;
      if (typeof img === 'string') return;
      if (!img.src) return;
      considerImage(img.alt || '', ciwNormalizeSrc(img.src));
    });

    return { front: galleryFront, side: gallerySide };
  }

  function ciwFindGalleryFrontSrc(product, variant) {
    var colorMeta = ciwGetColorOptionMeta(product);
    var isMultiColor = colorMeta.valueCount > 1;
    var variantColor = ciwGetVariantColor(product, variant, colorMeta.position);
    var galleryFront = null;
    var gallerySide = null;

    if (variantColor) {
      var matched = ciwScanColorMatchedGallery(product, variantColor, colorMeta.position);
      galleryFront = matched.front;
      gallerySide = matched.side;
    }

    if (!galleryFront && !gallerySide && !isMultiColor) {
      (product.images || []).forEach(function (img) {
        if (galleryFront && gallerySide) return;
        if (!img) return;
        var alt = typeof img === 'string' ? '' : img.alt || '';
        var src = typeof img === 'string' ? ciwNormalizeSrc(img) : ciwNormalizeSrc(img.src);
        if (ciwImageIsSide(alt, src)) {
          if (!gallerySide) gallerySide = src;
        } else if (!galleryFront) {
          galleryFront = src;
        }
      });
    }

    if (galleryFront) return galleryFront;
    if (gallerySide) return gallerySide;
    return null;
  }

  function ciwVariantImageMatchesColor(product, variant, colorPosition, variantColor) {
    var assigned = ciwGetVariantAssignedImageMeta(product, variant);
    if (!assigned.src || !assigned.alt) return false;
    if (!variantColor) return true;
    return ciwMatchColorInAlt(assigned.alt, product, colorPosition) === variantColor;
  }

  function ciwGetVariantAssignedImageMeta(product, variant) {
    if (!variant) return { src: '', alt: '' };
    if (variant.featured_image && variant.featured_image.src) {
      return {
        src: ciwNormalizeSrc(variant.featured_image.src),
        alt: variant.featured_image.alt || ''
      };
    }
    var imageId = variant.image_id;
    if (!imageId) return { src: '', alt: '' };
    var imgs = product.images || [];
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img && img.id === imageId && img.src) {
        return { src: ciwNormalizeSrc(img.src), alt: img.alt || '' };
      }
    }
    return { src: '', alt: '' };
  }

  function ciwGetVariantFrontUrl(product, variant) {
    if (!variant) return '';

    var colorMeta = ciwGetColorOptionMeta(product);
    var isMultiColor = colorMeta.valueCount > 1;
    var variantColor = ciwGetVariantColor(product, variant, colorMeta.position);
    var gallerySrc = ciwFindGalleryFrontSrc(product, variant);

    if (gallerySrc) return gallerySrc;

    var assigned = ciwGetVariantAssignedImageMeta(product, variant);
    if (assigned.src && ciwVariantImageMatchesColor(product, variant, colorMeta.position, variantColor)) {
      return assigned.src;
    }
    if (assigned.src && !isMultiColor) return assigned.src;

    if (product.featured_image) return ciwNormalizeSrc(product.featured_image);
    if (product.images && product.images[0]) {
      var first = product.images[0];
      return ciwNormalizeSrc(typeof first === 'string' ? first : first.src);
    }
    return '';
  }

  function ciwGetVariantHoverUrl(product, variant) {
    if (!variant) return '';

    var colorMeta = ciwGetColorOptionMeta(product);
    var variantColor = ciwGetVariantColor(product, variant, colorMeta.position);
    var sideImage = null;
    var frontCount = 0;

    function considerColorMatchedImage(alt, src) {
      if (!alt) return;
      if (ciwMatchColorInAlt(alt, product, colorMeta.position) !== variantColor) {
        var variantColorL = (variantColor || '').toLowerCase();
        if (!variantColorL || alt.toLowerCase().indexOf(variantColorL) === -1) return;
      }
      if (ciwImageIsSide(alt, src)) {
        sideImage = { src: src };
      } else {
        frontCount += 1;
      }
    }

    if (variantColor) {
      (product.media || []).forEach(function (media) {
        if (media.media_type !== 'image') return;
        considerColorMatchedImage(media.alt || '', ciwMediaSrc(media));
      });
      (product.images || []).forEach(function (img) {
        if (!img || typeof img === 'string' || !img.src) return;
        considerColorMatchedImage(img.alt || '', ciwNormalizeSrc(img.src));
      });
    }

    if (frontCount >= 1 && sideImage) {
      return sideImage.src;
    }

    return '';
  }

  function ciwReadPlpScales() {
    var embedded = window.ciwPlpScales || {};
    var stored = {};
    try {
      stored = JSON.parse(localStorage.getItem('ciwPlpScales') || '{}');
    } catch (e) {}
    var merged = {};
    var key;
    for (key in embedded) {
      if (Object.prototype.hasOwnProperty.call(embedded, key)) merged[key] = embedded[key];
    }
    for (key in stored) {
      if (Object.prototype.hasOwnProperty.call(stored, key)) merged[key] = stored[key];
    }
    return merged;
  }

  function ciwWritePlpScales(scales) {
    try {
      localStorage.setItem('ciwPlpScales', JSON.stringify(scales));
    } catch (e) {}
  }

  function ciwSyncPlpScalesFromDom() {
    var scales = ciwReadPlpScales();
    document.querySelectorAll('.ciw-card[data-handle]').forEach(function (card) {
      var style = card.getAttribute('style') || '';
      if (style.indexOf('--ciw-plp-scale') === -1) return;
      var scaleMatch = style.match(/--ciw-plp-scale:\s*([^;]+)/);
      if (!scaleMatch) return;
      var hoverMatch = style.match(/--ciw-plp-hover-scale:\s*([^;]+)/);
      scales[card.dataset.handle] = {
        scale: scaleMatch[1].trim(),
        hover: hoverMatch ? hoverMatch[1].trim() : '1.25'
      };
    });
    ciwWritePlpScales(scales);
  }

  /* --- Recently viewed carousel --- */
  (function initRecentlyViewed() {
    var section = document.querySelector('[data-recently-viewed]');
    var track = document.querySelector('[data-recently-track]');
    if (!section || !track) return;

    ciwSyncPlpScalesFromDom();

    function isValidHandle(handle) {
      return typeof handle === 'string' && /^[a-z0-9-]+$/.test(handle);
    }

    function isLensAdvizorProduct(product) {
      if (!product) return true;
      if (product.type === 'LensAdvizor') return true;
      if (/^lens-replacement-/.test(product.handle || '')) return true;
      return (product.title || '').indexOf('Lens Replacement Package') !== -1;
    }

    function ciwBestSellerDisplayTitle(product) {
      var title = (product && product.title) || '';
      if (!title || !product.tags) return title;
      var tags = product.tags;
      if (typeof tags === 'string') tags = tags.split(',').map(function (t) { return t.trim(); });
      if (tags.indexOf('best-seller-list') === -1) return title;
      return title.replace(/\s+Eyeglasses$/i, '').trim();
    }

    var ids;
    try {
      ids = JSON.parse(localStorage.getItem('ciwRecentlyViewed') || '[]');
    } catch (e) {
      return;
    }
    if (!Array.isArray(ids) || !ids.length) return;

    ids = ids.filter(function (handle) {
      return isValidHandle(handle) && !/^lens-replacement-/.test(handle);
    });
    try {
      localStorage.setItem('ciwRecentlyViewed', JSON.stringify(ids));
    } catch (e) {}

    var validIds = ids.slice(0, 10).filter(isValidHandle);
    if (!validIds.length) return;

    Promise.all(
      validIds.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) {
            if (!r.ok) return null;
            return r.json();
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var houseBrands = ['4u', 'peachtree', 'millennial', 'di-caprio', 'grande', 'trendy'];
      var houseMobileScaleBrands = ['4u', 'peachtree', 'millennial', 'di-caprio', 'grande'];
      var noScaleHandles = ['boss-boss-1557-o-f-s', 'burberry-be2404f'];
      var lightScaleHandles = ['ray-ban-rb5154-clubmaster-1', 'ray-ban-rb5154'];
      var rendered = 0;

      function toVendorHandle(vendor) {
        return (vendor || '')
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '');
      }

      function isHouseBrand(vendorHandle) {
        return houseBrands.some(function (brand) {
          return vendorHandle.indexOf(brand) !== -1;
        });
      }

      function isHouseMobileScale(vendorHandle) {
        return houseMobileScaleBrands.some(function (brand) {
          return vendorHandle.indexOf(brand) !== -1;
        });
      }

      function getCiwCardMeta(product) {
        var shouldScale = true;
        var isDesigner = true;
        var shouldScaleLight = false;
        var isHouse = false;
        var plpHoverScale = '1.25';
        var plpStored = ciwReadPlpScales()[product.handle];
        var plpScale = plpStored && plpStored.scale;

        if (isHouseBrand(toVendorHandle(product.vendor))) {
          shouldScale = false;
          isDesigner = false;
          isHouse = true;
        }
        if (noScaleHandles.indexOf(product.handle) !== -1) {
          shouldScale = false;
          plpHoverScale = '1';
        }
        if (lightScaleHandles.indexOf(product.handle) !== -1) {
          shouldScale = false;
          shouldScaleLight = true;
          plpHoverScale = '1.15';
        }
        if (plpScale) {
          shouldScale = false;
          shouldScaleLight = false;
          if (plpStored && plpStored.hover) plpHoverScale = plpStored.hover;
        }

        var cardClass = 'ciw-card';
        if (isHouse) cardClass += ' ciw-card--house';
        if (isHouseMobileScale(toVendorHandle(product.vendor))) cardClass += ' ciw-card--house-mobile-scale';
        if (plpScale) cardClass += ' ciw-card--plp-scale';
        else if (shouldScale) cardClass += ' ciw-card--scale';
        if (shouldScaleLight) cardClass += ' ciw-card--scale-light';
        if (isDesigner) cardClass += ' ciw-card--designer';

        return {
          className: cardClass,
          inlineStyle: plpScale
            ? '--ciw-plp-scale: ' + plpScale + '; --ciw-plp-hover-scale: ' + plpHoverScale + ';'
            : ''
        };
      }

      products.forEach(function (p) {
        if (!p || !isValidHandle(p.handle) || isLensAdvizorProduct(p)) return;

        var vendorHandle = toVendorHandle(p.vendor);
        var cardVariant = ciwGetCardVariant(p);
        var frontUrl = ciwGetVariantFrontUrl(p, cardVariant);
        var hoverUrl = ciwGetVariantHoverUrl(p, cardVariant);
        var hasHover = hoverUrl && ciwBaseImageUrl(hoverUrl) !== ciwBaseImageUrl(frontUrl);

        var cardMeta = getCiwCardMeta(p);
        var card = document.createElement('div');
        card.className = cardMeta.className + (hasHover ? ' ciw-card--has-hover' : '');
        if (cardMeta.inlineStyle) card.setAttribute('style', cardMeta.inlineStyle);
        card.dataset.vendor = vendorHandle;
        card.dataset.handle = p.handle;

        var imageLink = document.createElement('a');
        imageLink.href = '/products/' + p.handle;
        imageLink.className = 'ciw-card__image';

        if (frontUrl) {
          var imageEl = document.createElement('img');
          imageEl.className = 'ciw-card__img ciw-card__img--default';
          imageEl.src = frontUrl;
          imageEl.alt = p.title || '';
          imageEl.loading = 'lazy';
          imageLink.appendChild(imageEl);

          if (hasHover) {
            var hoverEl = document.createElement('img');
            hoverEl.className = 'ciw-card__img ciw-card__img--hover';
            hoverEl.src = hoverUrl;
            hoverEl.alt = p.title || '';
            hoverEl.loading = 'lazy';
            imageLink.appendChild(hoverEl);
          }
        }
        card.appendChild(imageLink);

        var infoLink = document.createElement('a');
        infoLink.href = '/products/' + p.handle;
        infoLink.className = 'ciw-card__info';

        var nameWrap = document.createElement('div');
        nameWrap.className = 'ciw-card__name';

        var titleEl = document.createElement('span');
        titleEl.className = 'ciw-card__title product-title';
        titleEl.textContent = ciwBestSellerDisplayTitle(p);
        nameWrap.appendChild(titleEl);
        infoLink.appendChild(nameWrap);

        var priceWrap = document.createElement('div');
        priceWrap.className = 'ciw-card__price';

        var pricing = window.ciwFirst30CardPricing;
        if (pricing && typeof pricing.appendCardPrices === 'function') {
          pricing.appendCardPrices(priceWrap, p, cardVariant);
        } else if (cardVariant) {
          if (cardVariant.compare_at_price && cardVariant.compare_at_price > cardVariant.price) {
            var msrpEl = document.createElement('span');
            msrpEl.className = 'ciw-card__msrp';
            msrpEl.textContent = '$' + (cardVariant.compare_at_price / 100).toFixed(2);
            priceWrap.appendChild(msrpEl);
            priceWrap.appendChild(document.createTextNode(' '));
          }
          if (cardVariant.price) {
            var nowEl = document.createElement('span');
            nowEl.className = 'ciw-card__now';
            nowEl.textContent = '$' + (cardVariant.price / 100).toFixed(2);
            priceWrap.appendChild(nowEl);
          }
        }

        infoLink.appendChild(priceWrap);
        card.appendChild(infoLink);
        track.appendChild(card);
        rendered += 1;
      });

      if (!rendered) return;
      section.style.display = '';
      document.dispatchEvent(new CustomEvent('ciw:collection-updated'));
    });

    function getAmount() {
      var card = track.querySelector('.ciw-card');
      return card ? card.offsetWidth + 20 : 300;
    }

    function updateScrolled() {
      section.classList.toggle('is-scrolled', track.scrollLeft > 5);
    }

    track.addEventListener('scroll', updateScrolled, { passive: true });
    var next = document.querySelector('[data-recently-next]');
    var prev = document.querySelector('[data-recently-prev]');
    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        track.scrollBy({ left: getAmount(), behavior: 'smooth' });
      });
    }
    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        track.scrollBy({ left: -getAmount(), behavior: 'smooth' });
      });
    }
  })();
})();
